
import { ThemeProvider } from "styled-components";
import { customerTheme } from "../theme";

import {
  Box,
} from "@chakra-ui/react";
import WebNavbar from "../components/web/WebNavbar";
import WebFooter from "../components/web/WebFooter";

const WebLayout = ({ children }) => {
  return (
    <ThemeProvider theme={customerTheme}>
      <Box
        bg={customerTheme.background}  
        color={customerTheme.color}    
        minH="100vh"                   
        display="flex"
        flexDirection="column"         
        px={0}                         
      >
        <WebNavbar />
        <Box pt="20px">
          {children}
        </Box>
        <WebFooter />
      </Box>
    </ThemeProvider>
  );
};

export default WebLayout;
